import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useAuthId } from '@/hooks/useAuthId';
import { installGlobalHandlers, setErrorReporterIdentity, trackBreadcrumb } from '@/lib/telemetry';

export function ErrorTelemetryProvider({ children }: { children: React.ReactNode }) {
  const { userId, isAuthenticated, isResolved } = useAuthId();
  const location = useLocation();

  useEffect(() => {
    const uninstallGlobalHandlers = installGlobalHandlers();
    return uninstallGlobalHandlers;
  }, []);

  useEffect(() => {
    if (!isResolved) return;
    setErrorReporterIdentity({
      userId: isAuthenticated ? userId : null,
      anonymousId: isAuthenticated ? null : userId,
      isAnonymous: !isAuthenticated,
    });
  }, [isAuthenticated, isResolved, userId]);

  useEffect(() => {
    trackBreadcrumb('navigation', location.pathname);
  }, [location.pathname]);

  return <>{children}</>;
}
